define('app/sf/as/array/sf-as-array-filter',[],function () {
	return function objectAsArrayFilter(input) {
		var out;
		if (angular.isObject(input)) {
			out = [];
			angular.forEach(input, function (value) {
				out.push(value);
			});
		}
		else {
			if (input !== null && angular.isDefined(input)) {
				out = [input];
			}
		}
		return out;
	};
});
